<template>
  <div class="audio-main">
    <audio
      src="img/blank.mp3"
      ref="audio"
      @ended="next"
      controls
    ></audio>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    queue: Array
  },
  data() {
    return {
      queueNow: 0
    };
  },
  computed: {
    ...mapState(["audio"])
  },
  methods: {
    play() {
      this.$refs.audio.src = this.audio.src;
      this.$refs.audio.load();
      this.$refs.audio.play();
      this.$store.commit("setAudio", { playing: true });
    },
    pause() {
      this.$refs.audio.pause();
      this.$store.commit("setAudio", { playing: false });
    },
    playQueue(num = this.queueNow) {
      this.$store.commit("setAudio", {
        inQueue: true,
        src: this.queue[num]
      });
      this.$nextTick(() => {
        this.play();
        this.queueNow = num;
      });
    },
    next() {
      if (this.audio.inQueue) {
        const num =
          this.queueNow === this.queue.length - 1 ? 0 : this.queueNow + 1;
        this.playQueue(num);
      } else {
        this.pause();
      }
    }
  }
};
</script>

<style>
.audio-main {
  display: none;
}
</style>
